import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useContext } from "react";
import { FormContext } from "../ImsAuditMainstage2";
import * as yup from "yup";
import FormikControl from '../../../../hoc/formikComponents/FormikControl.js'

function BasicInfo3() {
    const { activeStepIndex, setActiveStepIndex, formData, setFormData,
        technicalExpertList, setTechnicalExpertList,
        leadauditorList, setLeadauditorList,
        initialValues, setInitialValues,
        mutationTechnicalExpertDetails, mutationLeadAudiorDetails, mutationAssisAuditorDetails,
        OrgList, mutationgetCompanyDetails,
        saveData, options,
        assitAuditorList, setassitAuditorList,
        OrgListOrg, typeofaddressed, typeofadequate

    } = useContext(FormContext);

    const renderError = (message) => (
        <p className="italic text-red-600">{message}</p>
    );

    const ValidationSchema = yup.object().shape({
        // workspaceName: yup.string().required(),
        // workspaceURL: yup.string().url().required(),
    });

    return (
        <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            onSubmit={(values) => {
                const data = { ...formData, ...values };
                saveData(values);
                setActiveStepIndex(activeStepIndex + 1);
            }}>
            <Form className="flex flex-col justify-center items-center">


                <div className="formOuterDiv">
                    <table>
                        <thead>
                            <tr>
                                <th scope="col">Sr.No</th>
                                <th scope="col">Cl.No</th>
                                <th scope="col" width="50%">Documentation Requirements</th>
                                <th scope="col">Adddressed(Yes/No)</th>
                                <th scope="col">Adequate(Yes/No)</th>
                                <th scope="col" width="30%">Remarks / Concern No.</th>
                            </tr>
                        </thead>
                       <tbody>
                       <tr>
                              
                              <td>7</td>
                              <td>6.1.2</td>
                               <td>
                               a)	Whether the org. has maintained a documented information (for EMS) of its:
i)	environmental aspects and associated environmental impacts;
ii)	criteria used to determine its significant environmental aspects;
iii)	significant environmental aspects.
b)	Whether the organization has maintained and retained the documented information of its methodology(ies) and criteria for the assessment of OHS risks.



                               </td>
                               <td>
                                   <FormikControl control='selecttable' options={typeofaddressed} name='typeofaddressedseven' style={{ textAlign: "center" }} /> 
                               </td>
                               <td>
                                   <FormikControl control='selecttable' options={typeofadequate} name='typeofadequateseven' style={{ textAlign: "center" }} /> 
                               </td>
                               <td>
                               <FormikControl control='inputtable' type="text" name='remarkseven' className="form-control" />
                               </td>
                           </tr>
                           <tr>
                              
                              <td>8</td>
                              <td>6.1.3</td>
                               <td>
                               a)	Whether the organization has maintained documented information of its 	compliance obligations? (for EMS)
b)	Whether the organization has maintained and retained documented information 	on its legal and other requirements and ensured its updation. (for OHSMS)




                               </td>
                               <td>
                                   <FormikControl control='selecttable' options={typeofaddressed} name='typeofaddressedeight' style={{ textAlign: "center" }} /> 
                               </td>
                               <td>
                                   <FormikControl control='selecttable' options={typeofadequate} name='typeofadequateeight' style={{ textAlign: "center" }} /> 
                               </td>
                               <td>
                               <FormikControl control='inputtable' type="text" name='remarkeight' className="form-control" />
                               </td>
                           </tr>
                           <tr>
                              
                              <td rowSpan={3}>9</td>
                              <td rowSpan={3}>6.1.4</td>
                               <td>
                               a)	Whether the organization has planned actions to address:
i)	risks& opportunities
ii)	significant environmental aspects (for EMS)
iii)	compliance obligations
iv)	prepare for and respond to emergency situations (for OHSMS)


                               </td>
                               <td>
                                   <FormikControl control='selecttable' options={typeofaddressed} name='typeofaddressednine' style={{ textAlign: "center" }} /> 
                               </td>
                               <td>
                                   <FormikControl control='selecttable' options={typeofadequate} name='typeofadequatenine' style={{ textAlign: "center" }} /> 
                               </td>
                               <td>
                               <FormikControl control='inputtable' type="text" name='remarknine' className="form-control" />
                               </td>
                           </tr>
                           <tr>
                              
                            
                               <td>
                               b)	Whether the plan include mechanism to integrate and implement the actions into 	its QMS, EMS and OHSMS or other business processes?

                               </td>
                               <td>
                                   <FormikControl control='selecttable' options={typeofaddressed} name='typeofaddressednine1' style={{ textAlign: "center" }} /> 
                               </td>
                               <td>
                                   <FormikControl control='selecttable' options={typeofadequate} name='typeofadequatenine1' style={{ textAlign: "center" }} /> 
                               </td>
                               <td>
                               <FormikControl control='inputtable' type="text" name='remarknine1' className="form-control" />
                               </td>
                           </tr>
                           <tr>
                              
                            
                              <td>
                              c)	Whether the plan specify mechanism to evaluate the effectiveness of these 	actions?

                              </td>
                              <td>
                                  <FormikControl control='selecttable' options={typeofaddressed} name='typeofaddressednine2' style={{ textAlign: "center" }} /> 
                              </td>
                              <td>
                                  <FormikControl control='selecttable' options={typeofadequate} name='typeofadequatenine2' style={{ textAlign: "center" }} /> 
                              </td>
                              <td>
                              <FormikControl control='inputtable' type="text" name='remarknine2' className="form-control" />
                              </td>
                          </tr>
                          <tr>
                              
                              <td>10a</td>
                              <td rowSpan={2}>6.2.1</td>
                               <td>
                               Whether top management has established a documented Objectives at relevant functions, levels & QMS processes?


                               </td>
                               <td>
                                   <FormikControl control='selecttable' options={typeofaddressed} name='typeofaddressedten' style={{ textAlign: "center" }} /> 
                               </td>
                               <td>
                                   <FormikControl control='selecttable' options={typeofadequate} name='typeofadequateten' style={{ textAlign: "center" }} /> 
                               </td>
                               <td>
                               <FormikControl control='inputtable' type="text" name='remarkten' className="form-control" />
                               </td>
                           </tr>
                           <tr>
                              
                           <td>10b</td>
                              
                               <td>
                               Whether documented Objectives:
i)	are consistent with quality,environmental & OHS policy?
ii)	are measurable (if practicable for EMS& OHSMS)?
iii)	take into account applicable requirements,compliance obligations, significant environmental aspects and its risks & opportunities and the results of consultation with workers and workers’ representatives (if exist) (for OHSMS)
iv)	are relevant to conformity of products and services and to enhancement of customer satisfaction?
v)	are monitored?
vi)	are communicated?
vii)	are updated as appropriate?


                               </td>
                               <td>
                                   <FormikControl control='selecttable' options={typeofaddressed} name='typeofaddressedten1' style={{ textAlign: "center" }} /> 
                               </td>
                               <td>
                                   <FormikControl control='selecttable' options={typeofadequate} name='typeofadequateten1' style={{ textAlign: "center" }} /> 
                               </td>
                               <td>
                               <FormikControl control='inputtable' type="text" name='remarkten1' className="form-control" />
                               </td>
                           </tr>
                           <tr>
                           <td>10c</td>
                              <td>6.2.2</td>
                              <td>
                              Whether the organization has maintained and retained documented information on the OHS objectives and plans to achieve them. (for OHSMS only)

                              </td>
                              <td>
                                  <FormikControl control='selecttable' options={typeofaddressed} name='typeofaddressedeleven' style={{ textAlign: "center" }} /> 
                              </td>
                              <td>
                                  <FormikControl control='selecttable' options={typeofadequate} name='typeofadequateeleven' style={{ textAlign: "center" }} /> 
                              </td>
                              <td>
                              <FormikControl control='inputtable' type="text" name='remarkeleven' className="form-control" />
                              </td>
                          </tr>
                          <tr>
                           <td>11</td>
                              <td>7.4</td>
                              <td>
                              Whether the organization has established, implemented and maintained the process(es) needed for internal and external communications relevant to the EMS?

                              </td>
                              <td>
                                  <FormikControl control='selecttable' options={typeofaddressed} name='typeofaddressedtwelve' style={{ textAlign: "center" }} /> 
                              </td>
                              <td>
                                  <FormikControl control='selecttable' options={typeofadequate} name='typeofadequatetwelve' style={{ textAlign: "center" }} /> 
                              </td>
                              <td>
                              <FormikControl control='inputtable' type="text" name='remarktwelve' className="form-control" />
                              </td>
                          </tr>
                          <tr>
                           <td>12</td>
                              <td>8.1</td>
                              <td>
                              Whether the organization has determined, maintained & retained documented information to demonstrate that the processes are carried out as planned & conformity of products & services to the requirements are demonstrated?
                              </td>
                              <td>
                                  <FormikControl control='selecttable' options={typeofaddressed} name='typeofaddressedthirteen' style={{ textAlign: "center" }} /> 
                              </td>
                              <td>
                                  <FormikControl control='selecttable' options={typeofadequate} name='typeofadequatethirteen' style={{ textAlign: "center" }} /> 
                              </td>
                              <td>
                              <FormikControl control='inputtable' type="text" name='remarkthirteen' className="form-control" />
                              </td>
                          </tr>
                          <tr>
                           <td>13</td>
                              <td>8.2</td>
                              <td>
                              Whether the organization has established, implemented and maintained the process(es) needed to prepare for and respond to identified potential emergency situations and whether documented information provides confidence that the process(es) is (are) carried out as planned?                              </td>
                              <td>
                                  <FormikControl control='selecttable' options={typeofaddressed} name='typeofaddressedthirteen1' style={{ textAlign: "center" }} /> 
                              </td>
                              <td>
                                  <FormikControl control='selecttable' options={typeofadequate} name='typeofadequatethirteen1' style={{ textAlign: "center" }} /> 
                              </td>
                              <td>
                              <FormikControl control='inputtable' type="text" name='remarkthirteen1' className="form-control" />
                              </td>
                          </tr>
                       </tbody>
                    </table>
                </div>
                <div className="card-footer">
                    <div className="row">
                        <div className="col-sm-1"></div>

                        <div className="col-sm-2">
                            <button type="button" className="btn btn-primary float-left" onClick={() => setActiveStepIndex(activeStepIndex - 1)}>previous</button>
                        </div>
                        <div className="col-sm-7"></div>
                        <div className="col-sm-2">
                            <button type="submit" className="btn btn-primary float-right">Next</button>
                        </div>
                    </div>
                </div>
            </Form>
        </Formik>
    );
}

export default BasicInfo3;